import styles from './article.module.sass'

import Button from '../basic/button'
import Image from '../basic/image'

function Article(props) {
	let fields = props.fields

	return <div className={styles.article}>
		<h1>{fields.title}</h1>
		<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>
		{fields.image?.url && <Image {...fields.image} />}
		{fields.article_url &&
			<Button fields={{button: {url: fields.article_url, title: 'View Publication', target: '_blank'}}} className={styles.button}></Button>
		}
		
		<Button fields={{button: {url: fields.attachment.link, title: 'View PDF', target: '_blank'}}} className={styles.button}></Button>
	</div>
}

export default Article